import { Box, Typography, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'

const Unauthorized = () => {
  const navigate = useNavigate()
  return (
    <Box
      sx={{
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        textAlign: 'center',
      }}
    >
      <Typography variant="h4" gutterBottom>
        Access Restricted
      </Typography>
      <Typography variant="body1" color="text.secondary">
        You do not have sufficient permissions to view this section.
      </Typography>
      <Button variant="contained" onClick={() => navigate('/')}>
        Go back to Dashboard
      </Button>
    </Box>
  )
}

export default Unauthorized


